import type React from 'react';

import * as styles from './styles';

import { ControlButton } from '../ControlButton/ControlButton';

export type MapType = 'roadmap' | 'hybrid';

export interface MapTypeControlProps {
  currentType: MapType;
  onTypeChange: (type: MapType) => void;
}

export const MapTypeControl: React.FC<MapTypeControlProps> = ({ onTypeChange, currentType }) => {
  const isRoadType = currentType === 'roadmap';

  const handleTypeChange = (type: MapType) => () => {
    onTypeChange(type);
  };

  return (
    <div className={styles.mapTypeControl}>
      <ControlButton className='px-2.5 py-1' onClick={handleTypeChange('roadmap')} text='Mapa' selected={isRoadType} />
      <ControlButton className='px-2.5 py-1 ml-1' onClick={handleTypeChange('hybrid')} text='Satélite' selected={!isRoadType} />
    </div>
  );
};
